export const URL =
   process.env.NODE_ENV === "production" ? "" : "http://localhost:5000";
export const URLImage =
   process.env.NODE_ENV === "production" ? "" : "http://localhost:5000/";
